<template>
    <v-dialog v-model="vmodel" max-width="800"> 
        <v-card>
            <v-card-title class="primary white--text" style="font-family: Lexia !important; font-size: 22px;">
                Information
            </v-card-title>

            <v-card-text style="max-height: 60vh; overflow-y: auto; text-align: left;">
                <p class="text--primary" style="margin-top: 20px;">
                    Through our EcoPharmacoVigilance, reported measured environmental concentration (MEC) data is extracted and formatted for transparent visualization and further risk-based analysis by any interested user via this EcoPharmacoVigilance Dashboard.
                </p>
                <p class="text--primary">
                    The information contained in this interactive dashboard can be filtered by substance, protection goal, environmental compartment or region using the options in the menu ribbon. Citations of the original scientific literature can be found for each data point reflected on the map. Selecting a specific point of interest displays the original reference, including API, compartment, GIS location, and risk quotient (RQ).              
                </p>
                <p class="text--primary">
                    The relative risk posed by a substance to the environment in a specific location can be understood by its risk quotient (RQ), which is calculated using available MEC data for that location and the predicted no-effect concentration (PNEC) for the substance. Where concentrations are reported for effluents before entry into the aquatic environment an adjustment factor of 10 is applied to account for this; consistent with dilution factors used in regulatory guidance. However, this is not appropriate for wetland environments and effluents which are considered at face value instead.    
                </p>
                <p class="text--primary">
                    PNECs mark a concentration of a substance in any environment below which adverse effects will most likely not occur during long-term or short-term exposure. These values are conservative and are established based on ecotoxicology studies and additional safety factors. The PNECs displayed in the tool are based on risk to aquatic organisms only, however, this will be expanded to include other protection goals in future. Where multiple MECs exist, a semi-probabilistic environmental risk assessment is conducted with maximum, median, mean and 95th percentile RQs calculated.             
                </p>
                <p class="text--primary">
                    The risk categories used in the tool visualizations are defined as follows: 
                    <ul class="pt-2">
                        <li>No detect RQ = 0</li>
                        <li>Insignificant risk 0 &lt; RQ &lt;= 0.1</li>
                        <li>Low risk 0.1 &lt; RQ &lt;= 1</li>
                        <li>Moderate risk 1 &lt; RQ &lt;= 10</li>
                        <li>High-risk RQ &gt; 10</li>
                    </ul>
                </p>

                <p class="text--primary">
                    The RQ Distribution Chart (top of the middle panel) displays the percentage share of RQs falling into these risk categories. The category “insignificant risk” is further broken down into three bins by order of magnitude (0 &lt; RQ &lt;  0.001, 0.001 &lt;  RQ &lt;  0.01, 0.01 &lt;  RQ &lt; 0.1). Ranges are displayed by mouse-over.               
                </p>
                <p class="text--primary">
                    For further information on the properties of the APIs that determine their environmental distribution and degradation and on the ecotoxicology data that informs the predicted no-effect concentrations, please refer to the <a href='https://www.astrazeneca.com/content/dam/az/PDF/2017/Environmental_risk_data_relating_to_our_medicines.pdf'><u>environmental risk assessments</u></a>
                </p>
                <p class="text--primary">
                    Please note that, while some of the APIs included are currently patent-protected, others are not necessarily exclusively manufactured or distributed by AstraZeneca.                
                </p>
                <p class="text--primary">
                    The MEC values extracted from the published literature are taken at face value and AstraZeneca cannot accept responsibility for the quality of this data or the detection methods employed. Due to limitations of the search methodology, the data included may not be comprehensive of all published information and users are invited to share any additional published data by contacting <u><a href="mailto:Ecopharmacovigilance@AstraZeneca.com">Ecopharmacovigilance@AstraZeneca.com</a></u>.               
                </p>
                <p class="text--primary">
                  
                </p>
                
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn 
                    
                    color="primary"
                    @click="vmodel = false"
                    class="pt-1"
                >
                    close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped>
    a {
        text-decoration: none;
    }
</style>
<style>
    a:hover i {
        color: var(--v-primary-base) !important;
    }
</style>

<script>
    export default {
        props: {
            value: {
                type: Boolean,
            },
        },
        watch: {
            value() {
                this.$emit('input', this.value)
            }
        },
        computed: {
            vmodel: {
                get() {
                    return this.value
                },
                set(localValue) {
                    this.$emit('input', localValue)
                }
            },
        },
    }
</script>
